<template>
  <modal @close_modal="close_modal" :loading="loading" :title="$t('set_labels.edit_selected_labels')">
     <template v-slot:title>
       {{$t('set_labels.modal_title')}} {{name}}
     </template>
    <template v-slot:buttons>
       <v-btn
          color="primary"
          text
          id="cancel_button"
          @click="close_modal"
      >
        {{$t('set_labels.modal_cancel')}}
      </v-btn>

      <v-btn
          color="primary"
          text
          id="save_button"
          @click="save"
      >
        {{$t('set_labels.modal_save')}}
        <v-icon
            dark
            primary
            right
        >
          fas fa-level-down-alt fa-rotate-90
        </v-icon>
      </v-btn>
     </template>
     <template v-slot:content>
      <row>
        <col12 style="text-align:right">
          <h4>{{$t('set_label_sets.selected_labels')}}
            <span v-if="selected_labels.length > 0">({{ selected_labels.length }})</span>
          </h4>
          <v-chip v-for="label in displayed_selected_labels" :key="label.id" close @click:close="() => unselect_label(label.id)"
                  :dark="true" small
                  :style="{ 'font-weight': 'bold', 'background-color': `rgba(${label.color})` }">
            {{ label.name }}
          </v-chip>
          <v-chip
            v-if="hidden_selected_count > 0"
            small
            class="selected-labels-more"
          >
            {{ $t('set_label_sets.selected_labels_more', { n: hidden_selected_count }) }}
          </v-chip>
        </col12>
       </row>
       <row>
         <col6>{{$t('set_labels.modal_parent')}}</col6>
         <col6>
           <search-label-autocomplete
                   id="edit_multi_label_parent"
                   :track_last_used="false"
                   :allow_create_label="false"
                   :clear_on_select="false"
                   :value="parentName"
                   :placeholder="$t('set_labels.modal_parent_placeholder')"
                   @label-selected="on_parent_selected"
                   @cleared="on_parent_cleared"
           ></search-label-autocomplete>
         </col6>
       </row>
       <row>
         <col6>{{$t('set_labels.modal_type')}} </col6>
         <col6>
           <autocomplete
           v-model="type"
          :options="type_values"
         ></autocomplete>
         </col6>
       </row>
       <row>
         <col6>{{$t('set_labels.modal_color')}}</col6>
         <col6>
           <v-color-picker
                   v-model="color"
                   dot-size="25"
                   hide-canvas
                   hide-inputs
                   hide-mode-switch
                   hide-sliders
                   show-swatches
                   swatches-max-height="200"
           ></v-color-picker>
         </col6>
       </row>
     </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import Col6 from "@/components/layout/Col6";
import Row from "@/components/layout/Row";
import Autocomplete from "@/components/Autocomplete";
import SearchLabelAutocomplete from "@/components/SearchLabelAutocomplete.vue";
import Label from "@/models/label";
import Col12 from "@/components/layout/Col12";

export default {
name: "EditMultiLabelDialog",
  components: {SearchLabelAutocomplete, Autocomplete, Row, Col6, Modal, Col12},
  props: {
    'item': {default: false},
    'labels': {default: () => []},
    'selected_labels_ids': {default: () => []},
  },
  data () {
    return {
      type_values: [{id:1, name:'Box'}, {id:2, name:'Point'}],
      'name': '',
      'type': '',
      'color': '',
      'parent': null,
      loading: false,
    }
  },
  methods: {
    on_parent_selected(label) {
      if (!label || label.id == null) {
        this.parent = null;
        return;
      }
      this.parent = label;
    },
    on_parent_cleared() {
      this.parent = null;
    },
    unselect_label(label_id) {
      let updated_selected_label_ids = this.selected_labels_ids.filter(id => id != label_id);
      this.$emit('select_label_ids', updated_selected_label_ids)
    },
    async save () {
        this.loading = true;
        let color = null;

        try {
          if(this.color && this.color.hex) {
            color = this.hexToRGB(this.color.hex);
          }
          else if(this.color) {
            color = this.hexToRGB(this.color);
          }
        } catch (error) {
          console.error('Error saving color', this.color, error);
        }

        let parent_id = null;
        if (this.parent && typeof this.parent === 'object' && this.parent.id != null) {
          parent_id = this.parent.id
        }
        const typeId =
          this.type && typeof this.type === 'object' && this.type.id != null
            ? this.type.id
            : (typeof this.type === 'number' ? this.type : undefined);

        await this.$api.label.patch_labels(this.selected_labels_ids, parent_id, color, typeId);

        for(let labelId of this.selected_labels_ids) {
          const label = new Label(labelId, this.name, typeId, color, parent_id)
          await this.$store.commit('label/update_item', {
            item: label,
            key_values: {
              type_id: typeId,
              color: color,
              parent_id: parent_id
            }
          });
        }

        await this.$store.dispatch('snackbars/add_success_snack', {
          'message': this.$t('snacks.label_saved'),
        })

        this.close_modal()
      },
      close_modal() {
        this.$emit('close_modal')
      },
      hexToRGB(hex, alpha) {
        let r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return r + "," + g + "," + b + "," + alpha
        } else {
            return r + "," + g + "," + b
        }
      },
      RGBToHex(r,g,b) {
        r = parseInt(r).toString(16);
        g = parseInt(g).toString(16);
        b = parseInt(b).toString(16);

        if (r.length == 1)
          r = "0" + r;
        if (g.length == 1)
          g = "0" + g;
        if (b.length == 1)
          b = "0" + b;

        return "#" + r + g + b;
      },
  },
  computed: {
    parentName () {
      return this.parent && this.parent.name ? this.parent.name : null;
    },
    selected_labels() {
      return this.labels.filter(label => this.selected_labels_ids.includes(label.id))
    },
    displayed_selected_labels() {
      return this.selected_labels.slice(0, 12);
    },
    hidden_selected_count() {
      return Math.max(0, this.selected_labels.length - 12);
    },
  },
  mounted() {
    let type_id = 1;
    let type_ids = this.type_values.map((elem) => {return elem.id});
    this.type = this.type_values[type_ids.indexOf(type_id)];
  }
}
</script>

<style scoped>
.selected-labels-more {
  font-weight: bold;
}
</style>